import documentGroupServer from "../../server/documentGroup";

const documentGroupModule = {
  namespaced: true,
  state: () => ({
    list: [],
    formGroupSubmit: {
      id: null,
      formGroupId: null,
      results: {},
      clientId: "",
      formIds: [],
      eocId: null
    },
    currentForm: null
  }),
  mutations: {
    async initializeFormGroupSubmit(
      state,
      { submitId, formGroupId, clientId, results, formIds, eocId }
    ) {
      state.formGroupSubmit.id = submitId;
      state.formGroupSubmit.clientId = clientId;
      state.formGroupSubmit.formGroupId = formGroupId;
      state.formGroupSubmit.results = results ? results : {};
      state.formGroupSubmit.formIds = formIds;
      state.formGroupSubmit.eocId = eocId;
    },
    setCurrentForm(state, data) {
      state.currentForm = data;
    }
  },
  actions: {
    async addFormGroupSubmit(context) {
      const result = await documentGroupServer.create({
        formGroupId: context.state.formGroupSubmit.formGroupId,
        episodeOfCareId: context.state.formGroupSubmit.eocId,
        patientId: context.state.formGroupSubmit.clientId
      });
      context.dispatch("fetchFormGroupSubmits", {
        formGroupId: context.state.formGroupSubmit.formGroupId,
        clientId: context.state.formGroupSubmit.clientId,
        eocId: context.state.formGroupSubmit.eocId
      });
      return result;
    },
    async editFormGroupSubmit(context, { submitId }) {
      await documentGroupServer.update(submitId, {});
      context.dispatch("fetchFormGroupSubmits", {
        formGroupId: context.state.formGroupSubmit.formGroupId,
        clientId: context.state.formGroupSubmit.clientId,
        eocId: context.state.formGroupSubmit.eocId
      });
    },
    async deleteFormGroupSubmit(
      context,
      { submitId, formGroupId, clientId, eocId }
    ) {
      const result = await documentGroupServer.delete(submitId);
      context.dispatch("fetchFormGroupSubmits", {
        formGroupId,
        clientId,
        eocId
      });
      return result;
    },
    async fetchFormGroupSubmits(context, { formGroupId, clientId, eocId }) {
      const forms = await documentGroupServer.query(
        formGroupId,
        clientId,
        eocId
      );
      context.state.list = forms;
    }
  },
  getters: {
    getFormGroupSubmitById: () => async id => {
      return await documentGroupServer.get(id);
    }
  }
};

export default documentGroupModule;
